import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ApplicationFacade } from '@ridango/components';
import { UserTicketActionCarrier } from '@ridango/core';

@Component({
    selector: 'rwidget-account-tickets-list',
    templateUrl: './account-tickets-list.component.html',
    styleUrls: ['./account-tickets-list.component.scss']
})
export class AccountTicketsListComponent {
    @Input() actions;
    @Input() useInputActions;
    @Input() tickets;
    @Input() locale;
    @Output() requestTicketAction: EventEmitter<UserTicketActionCarrier> = new EventEmitter();

    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(private applicationFacade: ApplicationFacade) {}

    ticketAction(action: UserTicketActionCarrier) {
        this.requestTicketAction.emit(action);
    }
}
